export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      portfolio: "Portfolio",
      process: "Process",
      contact: "Contact",
    },

    common: {
      requestDemo: "Request Demo",
      viewPortfolio: "View Portfolio",
      learnMore: "Learn more",
      getFreeConsultation: "Get Free Consultation",
      loadMoreProjects: "Load More Projects",
      startYourProject: "Start Your Project",
      scheduleCall: "Schedule a Call",
      getFreeProposal: "Get a Free Proposal",
      viewCaseStudies: "View Case Studies",
      subscribe: "Subscribe",
      subscribing: "Subscribing...",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      sitemap: "Sitemap",
    },

    hero: {
        titlePrefix: "Revolutionize Your",
        staticPrefix: "Digital",
        staticSuffix: "",
        rotating: ["Products", "Systems", "Solutions"],
      desc:
        "Transform your digital vision into reality with our cutting-edge development solutions. We craft exceptional web and mobile experiences that drive growth and exceed expectations.",
      stats: {
        projects: "Projects Delivered",
        clients: "Happy Clients",
        years: "Years Experience",
        support: "Support",
      },
    },

    trustedBy: {
      label: "Trusted by leading companies",
    },

    about: {
      badge: "About StartCode",
      title: "Transforming ideas into",
      highlight: " digital excellence",
      p1:
        "StartCode is a premier IT consultancy specializing in custom software development, web applications, and mobile solutions. With over 5 years of industry experience, we've helped businesses of all sizes accelerate their digital transformation journey.",
      p2:
        "Our team of expert developers, designers, and strategists work closely with clients to understand their unique challenges and deliver tailored solutions that drive measurable business results.",
      achievements: [
        "100+ Successful Projects",
        "50+ Enterprise Clients",
        "99.9% Uptime Guarantee",
        "24/7 Technical Support",
        "Agile Development Process",
        "ISO Certified Security",
      ],
      values: [
        {
          title: "Lightning Fast Delivery",
          description:
            "We deliver high-quality solutions with rapid turnaround times, without compromising on quality.",
        },
        {
          title: "Enterprise-Grade Security",
          description:
            "Built with security-first approach, ensuring your data and applications are always protected.",
        },
        {
          title: "Modern Tech Stack",
          description:
            "Using cutting-edge technologies and frameworks to future-proof your digital solutions.",
        },
        {
          title: "True Partnership",
          description:
            "We work as an extension of your team, providing ongoing support and strategic guidance.",
        },
      ],
    },

    servicesSection: {
      badge: "Our Services",
      title: "Comprehensive digital solutions for",
      highlight: " every need",
      desc:
        "From concept to deployment, we provide end-to-end development services that transform your vision into powerful digital solutions.",
      bottomCtaText: "Need a custom solution? Let's discuss your project requirements.",
      services: [
        {
          title: "Web Development",
          description:
            "Custom web applications built with modern frameworks like React, Vue, and Angular. Scalable, performant, and user-friendly solutions.",
          features: ["Responsive Design", "Progressive Web Apps", "E-commerce Solutions", "Content Management"],
        },
        {
          title: "Mobile Apps",
          description:
            "Native and cross-platform mobile applications for iOS and Android. Seamless user experience with optimal performance.",
          features: ["iOS & Android", "React Native", "Flutter Development", "App Store Optimization"],
        },
        {
          title: "Custom Solutions",
          description:
            "Tailored software solutions designed specifically for your business needs. From APIs to complex integrations.",
          features: ["API Development", "Database Design", "Third-party Integrations", "Automation Tools"],
        },
        {
          title: "Enterprise Software",
          description:
            "Robust enterprise-grade applications with advanced security, scalability, and compliance features.",
          features: ["Enterprise Architecture", "Cloud Solutions", "Security Audits", "Legacy Modernization"],
        },
      ],
    },

    portfolioSection: {
      badge: "Our Portfolio",
      title: "Showcasing our",
      highlight: " best work",
      desc: "Explore our portfolio of successful projects across various industries and technologies.",
      categories: {
        all: "All",
        web: "Web Development",
        mobile: "Mobile Development",
        branding: "Branding",
      },
      modal: {
        overview: "Project Overview",
        keyFeatures: "Key Features",
        results: "Results",
        tech: "Technologies Used",
        viewLive: "View Live Project",
        viewCode: "View Code",
        client: "Client",
        year: "Year",
        category: "Category",
      },
    },

    processSection: {
      badge: "Our Process",
      title: "From concept to",
      highlight: " launch",
      desc:
        "Our proven development process ensures successful project delivery with clear communication and measurable results at every stage.",
      steps: [
        {
          title: "Discovery & Research",
          description:
            "We dive deep into understanding your business needs, target audience, and project requirements through comprehensive research and stakeholder interviews.",
          details: ["Requirement analysis", "Market research", "Competitive analysis", "Technical feasibility"],
        },
        {
          title: "Design & Planning",
          description:
            "Our design team creates intuitive user experiences and develops detailed project roadmaps with clear milestones and deliverables.",
          details: ["UI/UX design", "Project roadmap", "Architecture planning", "Prototype development"],
        },
        {
          title: "Development & Testing",
          description:
            "Using agile methodologies, we build robust solutions with continuous testing and quality assurance throughout the development process.",
          details: ["Agile development", "Code reviews", "Quality assurance", "Performance optimization"],
        },
        {
          title: "Launch & Support",
          description:
            "We ensure smooth deployment and provide ongoing support, monitoring, and maintenance to keep your solution running optimally.",
          details: ["Deployment & launch", "Performance monitoring", "Ongoing support", "Feature updates"],
        },
      ],
      bottomCta: {
        title: "Ready to get started?",
        desc: "Let's discuss your project and create something amazing together.",
      },
    },

    metricsSection: {
      badge: "Our Impact",
      title: "Proven results that",
      highlight: " speak volumes",
      stats: [
        {
          value: "100+",
          label: "Projects Completed",
          description: "Successfully delivered projects across various industries",
        },
        {
          value: "50+",
          label: "Happy Clients",
          description: "Trusted by startups to enterprise companies worldwide",
        },
        {
          value: "4.9/5",
          label: "Client Satisfaction",
          description: "Average rating based on project feedback and reviews",
        },
        {
          value: "24/7",
          label: "Support Available",
          description: "Round-the-clock technical support and maintenance",
        },
      ],
      testimonials: {
        title: "What our clients say",
        desc:
          "Don't just take our word for it. Here's what our clients have to say about working with us.",
        items: [
          {
            quote:
              "StartCode transformed our vision into a reality. Their expertise and dedication resulted in a platform that exceeded our expectations.",
            author: "Sarah Johnson",
            role: "CTO, TechCorp",
          },
          {
            quote:
              "The team's attention to detail and commitment to quality is outstanding. They delivered our mobile app on time and within budget.",
            author: "Michael Chen",
            role: "Founder, StartupXYZ",
          },
          {
            quote:
              "Working with StartCode was seamless. They understood our requirements perfectly and provided innovative solutions.",
            author: "Emily Rodriguez",
            role: "Product Manager, InnovateLab",
          },
        ],
      },
    },

    ctaStrip: {
      title: "Ready to transform your\ndigital vision into reality?",
      desc:
        "Join 50+ companies who trust StartCode to deliver exceptional digital solutions. Let's discuss your project and create something extraordinary together.",
      trust: {
        projects: "Projects Delivered",
        clients: "Happy Clients",
        rating: "Client Rating",
        support: "Support",
      },
      limited:
        "🚀 Limited Time: Free consultation and project planning session for new clients. No commitment required - just valuable insights for your project.",
    },

    footer: {
      companyDesc:
        "Transforming digital visions into exceptional software solutions. We help businesses innovate and grow through cutting-edge technology.",
      quickLinksTitle: "Quick Links",
      servicesTitle: "Services",
      stayUpdatedTitle: "Stay Updated",
      stayUpdatedDesc: "Subscribe to our newsletter for the latest tech insights and project updates.",
      emailPlaceholder: "Enter your email",
      followUsTitle: "Follow Us",
      madeWith: "Made with ❤️ in Indonesia",
      copyright: "© 2024 StartCode. All rights reserved.",
      toast: {
        subscribedTitle: "Subscribed!",
        subscribedDesc: "You've been added to our newsletter. Thank you!",
      },
      servicesLinks: [
        "Web Development",
        "Mobile Apps",
        "Custom Solutions",
        "Enterprise Software",
        "UI/UX Design",
        "Consulting",
      ],
    },
  },

  id: {
    nav: {
      about: "Tentang",
      services: "Layanan",
      portfolio: "Portofolio",
      process: "Proses",
      contact: "Kontak",
    },

    common: {
      requestDemo: "Minta Demo",
      viewPortfolio: "Lihat Portofolio",
      learnMore: "Pelajari lebih lanjut",
      getFreeConsultation: "Konsultasi Gratis",
      loadMoreProjects: "Muat Lebih Banyak",
      startYourProject: "Mulai Proyek Anda",
      scheduleCall: "Jadwalkan Panggilan",
      getFreeProposal: "Dapatkan Proposal Gratis",
      viewCaseStudies: "Lihat Studi Kasus",
      subscribe: "Berlangganan",
      subscribing: "Memproses...",
      privacyPolicy: "Kebijakan Privasi",
      termsOfService: "Syarat Layanan",
      sitemap: "Peta Situs",
    },

    hero: {
        titlePrefix: "Revolusionerkan",
        staticPrefix: "",
        staticSuffix: "Digital",
        rotating: ["Solusi", "Sistem", "Produk"],
      desc:
        "Wujudkan visi digital Anda dengan solusi pengembangan modern. Kami membangun pengalaman web & mobile yang cepat, rapi, dan fokus pada pertumbuhan bisnis.",
      stats: {
        projects: "Proyek Terselesaikan",
        clients: "Klien Puas",
        years: "Tahun Pengalaman",
        support: "Dukungan",
      },
    },

    trustedBy: {
      label: "Dipercaya oleh berbagai perusahaan",
    },

    about: {
      badge: "Tentang StartCode",
      title: "Mengubah ide menjadi",
      highlight: " keunggulan digital",
      p1:
        "StartCode adalah konsultan IT yang fokus pada pengembangan software kustom, aplikasi web, dan solusi mobile. Dengan pengalaman lebih dari 5 tahun, kami membantu berbagai bisnis mempercepat transformasi digital.",
      p2:
        "Tim developer, designer, dan strategist kami bekerja dekat dengan klien untuk memahami tantangan dan menghadirkan solusi yang terukur dan berdampak.",
      achievements: [
        "100+ Proyek Berhasil",
        "50+ Klien Enterprise",
        "Jaminan Uptime 99,9%",
        "Dukungan Teknis 24/7",
        "Proses Agile Development",
        "Keamanan Bersertifikasi",
      ],
      values: [
        {
          title: "Pengerjaan Cepat & Terukur",
          description:
            "Kami mengirimkan solusi berkualitas dengan turnaround cepat tanpa mengorbankan kualitas.",
        },
        {
          title: "Keamanan Kelas Enterprise",
          description:
            "Dibangun dengan pendekatan security-first untuk menjaga data dan aplikasi Anda tetap aman.",
        },
        {
          title: "Tech Stack Modern",
          description:
            "Menggunakan teknologi dan framework terbaru agar solusi Anda siap berkembang di masa depan.",
        },
        {
          title: "Kemitraan Nyata",
          description:
            "Kami menjadi perpanjangan tim Anda, dengan dukungan berkelanjutan dan arahan strategis.",
        },
      ],
    },

    servicesSection: {
      badge: "Layanan Kami",
      title: "Solusi digital end-to-end untuk",
      highlight: " semua kebutuhan",
      desc:
        "Dari ide hingga rilis, kami menyediakan layanan pengembangan menyeluruh untuk mewujudkan visi Anda menjadi produk digital yang kuat.",
      bottomCtaText: "Butuh solusi khusus? Yuk diskusikan kebutuhan proyek Anda.",
      services: [
        {
          title: "Pengembangan Web",
          description:
            "Aplikasi web kustom dengan framework modern seperti React, Vue, dan Angular. Skalabel, cepat, dan user-friendly.",
          features: ["Desain Responsif", "Progressive Web Apps", "Solusi E-commerce", "Content Management"],
        },
        {
          title: "Aplikasi Mobile",
          description:
            "Aplikasi native dan cross-platform untuk iOS & Android. Pengalaman pengguna mulus dengan performa optimal.",
          features: ["iOS & Android", "React Native", "Flutter Development", "Optimasi App Store"],
        },
        {
          title: "Solusi Kustom",
          description:
            "Solusi software yang dirancang khusus sesuai kebutuhan bisnis Anda—dari API hingga integrasi kompleks.",
          features: ["Pengembangan API", "Desain Database", "Integrasi Pihak Ketiga", "Otomasi Tools"],
        },
        {
          title: "Software Enterprise",
          description:
            "Aplikasi enterprise yang robust dengan keamanan, skalabilitas, dan compliance tingkat tinggi.",
          features: ["Arsitektur Enterprise", "Solusi Cloud", "Audit Keamanan", "Modernisasi Sistem Lama"],
        },
      ],
    },

    portfolioSection: {
      badge: "Portofolio Kami",
      title: "Menampilkan",
      highlight: " karya terbaik",
      desc: "Jelajahi portofolio proyek sukses kami di berbagai industri dan teknologi.",
      categories: {
        all: "Semua",
        web: "Pengembangan Web",
        mobile: "Pengembangan Mobile",
        branding: "Branding",
      },
      modal: {
        overview: "Ringkasan Proyek",
        keyFeatures: "Fitur Utama",
        results: "Hasil",
        tech: "Teknologi yang Digunakan",
        viewLive: "Lihat Proyek (Live)",
        viewCode: "Lihat Kode",
        client: "Klien",
        year: "Tahun",
        category: "Kategori",
      },
    },

    processSection: {
      badge: "Proses Kami",
      title: "Dari konsep hingga",
      highlight: " rilis",
      desc:
        "Proses pengembangan kami memastikan proyek berjalan jelas, terukur, dan sukses dengan komunikasi yang rapi di setiap tahap.",
      steps: [
        {
          title: "Discovery & Riset",
          description:
            "Kami mendalami kebutuhan bisnis, target pengguna, dan requirement proyek melalui riset dan diskusi dengan stakeholder.",
          details: ["Analisis kebutuhan", "Riset pasar", "Analisis kompetitor", "Studi kelayakan teknis"],
        },
        {
          title: "Desain & Perencanaan",
          description:
            "Tim desain kami membuat UX yang intuitif dan menyusun roadmap proyek lengkap dengan milestone dan deliverables.",
          details: ["UI/UX design", "Roadmap proyek", "Perencanaan arsitektur", "Pembuatan prototype"],
        },
        {
          title: "Development & Testing",
          description:
            "Dengan metode agile, kami membangun solusi robust disertai testing dan QA terus-menerus sepanjang proses.",
          details: ["Agile development", "Code review", "Quality assurance", "Optimasi performa"],
        },
        {
          title: "Launch & Support",
          description:
            "Kami memastikan deployment mulus serta menyediakan monitoring, support, dan maintenance agar sistem tetap optimal.",
          details: ["Deployment & launch", "Monitoring performa", "Support berkelanjutan", "Update fitur"],
        },
      ],
      bottomCta: {
        title: "Siap mulai?",
        desc: "Mari diskusikan proyek Anda dan wujudkan sesuatu yang luar biasa bersama.",
      },
    },

    metricsSection: {
      badge: "Dampak Kami",
      title: "Hasil nyata yang",
      highlight: " berbicara",
      stats: [
        {
          value: "100+",
          label: "Proyek Selesai",
          description: "Berhasil deliver proyek lintas industri",
        },
        {
          value: "50+",
          label: "Klien Puas",
          description: "Dipercaya dari startup hingga enterprise",
        },
        {
          value: "4.9/5",
          label: "Kepuasan Klien",
          description: "Rating rata-rata berdasarkan feedback proyek",
        },
        {
          value: "24/7",
          label: "Dukungan Tersedia",
          description: "Support teknis dan maintenance sepanjang waktu",
        },
      ],
      testimonials: {
        title: "Kata klien kami",
        desc:
          "Bukan hanya kata kami—ini yang klien rasakan saat bekerja bersama StartCode.",
        items: [
          {
            quote:
              "StartCode mewujudkan visi kami menjadi kenyataan. Keahlian dan dedikasi mereka menghasilkan platform yang melampaui ekspektasi.",
            author: "Sarah Johnson",
            role: "CTO, TechCorp",
          },
          {
            quote:
              "Detail dan komitmen kualitas timnya luar biasa. Mereka mengirimkan mobile app kami tepat waktu dan sesuai budget.",
            author: "Michael Chen",
            role: "Founder, StartupXYZ",
          },
          {
            quote:
              "Kerja sama dengan StartCode sangat mulus. Mereka memahami kebutuhan kami dan memberi solusi yang inovatif.",
            author: "Emily Rodriguez",
            role: "Product Manager, InnovateLab",
          },
        ],
      },
    },

    ctaStrip: {
      title: "Siap mewujudkan\nvisi digital Anda?",
      desc:
        "Bergabung dengan 50+ perusahaan yang mempercayakan StartCode untuk deliver solusi digital terbaik. Yuk diskusikan proyek Anda.",
      trust: {
        projects: "Proyek Terselesaikan",
        clients: "Klien Puas",
        rating: "Rating Klien",
        support: "Dukungan",
      },
      limited:
        "🚀 Promo Terbatas: Sesi konsultasi & perencanaan proyek gratis untuk klien baru. Tanpa komitmen—hanya insight berharga untuk proyek Anda.",
    },

    footer: {
      companyDesc:
        "Mengubah visi digital menjadi solusi software yang luar biasa. Kami membantu bisnis bertumbuh dengan teknologi modern.",
      quickLinksTitle: "Navigasi",
      servicesTitle: "Layanan",
      stayUpdatedTitle: "Dapatkan Update",
      stayUpdatedDesc: "Langganan newsletter untuk insight teknologi dan update proyek terbaru.",
      emailPlaceholder: "Masukkan email Anda",
      followUsTitle: "Ikuti Kami",
      madeWith: "Dibuat dengan ❤️ di Indonesia",
      copyright: "© 2024 StartCode. Hak cipta dilindungi.",
      toast: {
        subscribedTitle: "Berhasil!",
        subscribedDesc: "Anda sudah terdaftar ke newsletter. Terima kasih!",
      },
      servicesLinks: [
        "Pengembangan Web",
        "Aplikasi Mobile",
        "Solusi Kustom",
        "Software Enterprise",
        "UI/UX Design",
        "Konsulting",
      ],
    },
  },
};
